require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-four-project-sponsors-eight-mentors-and-eighty-devs-walk-into-a-code-school.json") })
        }
      }, "path---blog-four-project-sponsors-eight-mentors-and-eighty-devs-walk-into-a-code-school");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-four-project-sponsors-eight-mentors-and-eighty-devs-walk-into-a-code-school!./.cache/json/blog-four-project-sponsors-eight-mentors-and-eighty-devs-walk-into-a-code-school.json
// module id = 823
// module chunks = 231608221292675